import { js_utils } from "./frfr-js-utils";


/*
FrFr FRIENDLY FRAMEWORK
frfr-virtel-utils
Version ID: 1a 2023-08-26r1
by 
// Please describe here if you customized this file
*/


export const is_virtel_object = (obj) => {
  if (js_utils.is_object(obj)) {
    if (typeof obj.virtelschemakey === 'string') {
      return true;
    }
  }
  return false;
};

